import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';

export const QuarantineActionStatus = {
  ACTION_STATUS_NONE: 0x0000,
  ACTION_STATUS_PENDING_REMOVE: 0x0001,
  ACTION_STATUS_PENDING_RESTORE: 0x0002,
  ACTION_STATUS_FAILED_REMOVE: 0x0003,
  ACTION_STATUS_FAILED_RESTORE: 0x0004,
  ACTION_STATUS_PENDING_RETRIEVE: 0x0005,
  ACTION_STATUS_IN_PROGRESS_RETRIEVE: 0x0006,
  ACTION_STATUS_SUCCEEDED_RETRIEVE: 0x0007,
  ACTION_STATUS_FAILED_RETRIEVE: 0x0008,
};

export const PendingTypes = [
  QuarantineActionStatus.ACTION_STATUS_PENDING_RESTORE,
  QuarantineActionStatus.ACTION_STATUS_PENDING_REMOVE,
  QuarantineActionStatus.ACTION_STATUS_PENDING_RETRIEVE,
  QuarantineActionStatus.ACTION_STATUS_IN_PROGRESS_RETRIEVE,
];

export const getTranslatedQuarantineActionStatusToName = () => {
  const translatedQuarantineActionStatusToName = {
    [QuarantineActionStatus.ACTION_STATUS_NONE]: translateFn('None'),
    [QuarantineActionStatus.ACTION_STATUS_PENDING_REMOVE]: translateFn('Pending remove'),
    [QuarantineActionStatus.ACTION_STATUS_PENDING_RESTORE]: translateFn('Pending restore'),
    [QuarantineActionStatus.ACTION_STATUS_PENDING_RETRIEVE]: translateFn('Pending retrieve'),
    [QuarantineActionStatus.ACTION_STATUS_IN_PROGRESS_RETRIEVE]: translateFn('Retrieve in progress'),
    [QuarantineActionStatus.ACTION_STATUS_SUCCEEDED_RETRIEVE]: translateFn('Retrieved'),
    [QuarantineActionStatus.ACTION_STATUS_FAILED_RETRIEVE]: translateFn('Retrieve failed'),
    [QuarantineActionStatus.ACTION_STATUS_FAILED_REMOVE]: translateFn('Remove failed'),
    [QuarantineActionStatus.ACTION_STATUS_FAILED_RESTORE]: translateFn('Restore failed'),
  };

  if (!Application.Main.product.isCloud()) {
    delete translatedQuarantineActionStatusToName[QuarantineActionStatus.ACTION_STATUS_PENDING_RETRIEVE];
    delete translatedQuarantineActionStatusToName[QuarantineActionStatus.ACTION_STATUS_IN_PROGRESS_RETRIEVE];
    delete translatedQuarantineActionStatusToName[QuarantineActionStatus.ACTION_STATUS_SUCCEEDED_RETRIEVE];
    delete translatedQuarantineActionStatusToName[QuarantineActionStatus.ACTION_STATUS_FAILED_RETRIEVE];
  }

  return translatedQuarantineActionStatusToName;
};

export const getTranslatedQuarantineActionStatusFilterValues = () => {
  const translatedQuarantineActionStatusFilterValues = Object.entries(getTranslatedQuarantineActionStatusToName()).map(
    ([value, label]) => ({
      value: Number(value),
      label,
    })
  );

  return translatedQuarantineActionStatusFilterValues;
};
